import { useEffect } from 'react';

import { checkChangedSignupUserSettingsAndUpdate } from 'domains/userSettings/actions/checkChangedSignupUserSettingsAndUpdate';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { useQueryEndpoint } from './useQueryEndpoint';

export const useCheckChangedSignupUserSettingsAndUpdate = () => {
  const { isLoggedIn } = useAuth();

  const [checkSettings] = useQueryEndpoint(
    checkChangedSignupUserSettingsAndUpdate,
  );

  useEffect(() => {
    if (isLoggedIn) {
      checkSettings();
    }
  }, [isLoggedIn, checkSettings]);
};
